import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { Subject } from 'rxjs';

import { I18nService } from '@ts/shared/i18n/util-core';
import { EnvironmentService } from '@ts/shared/util-environment';

import { MetaTagStrategyService } from './meta-tag-strategy.service';

export const DEFAULT_TITLE = 'Bormadago.com';

@Injectable({
  providedIn: 'root',
})
export class BormadagoTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private i18nService = inject(I18nService);
  private environmentService = inject(EnvironmentService);
  private metaStrategy = inject(MetaTagStrategyService);

  private titleUpdatedSubject = new Subject<void>();
  // Emits once a navigation's route title is set, which may wait for its
  // translation: a page titling itself from its own data sets it after this.
  readonly titleUpdated$ = this.titleUpdatedSubject.asObservable();

  override async updateTitle(snapshot: RouterStateSnapshot): Promise<void> {
    const titleKey = this.buildTitle(snapshot);
    let subtitle = '';
    if (titleKey) {
      subtitle = await this.i18nService.translate$(titleKey);
    }
    this.setTitle(subtitle);
    this.titleUpdatedSubject.next();

    /**
     * This is hack to set meta tag from router snapshot
     * because angular does not have meta strategy
     */
    this.metaStrategy.setMetaTag(snapshot);
  }

  setTitle(subtitle: string) {
    let title: string = DEFAULT_TITLE;
    if (this.environmentService.get().app === 'soladmin') {
      title = `Staff.${title}`;
    }

    if (subtitle) {
      title = `${subtitle} | ${title}`;
    }
    this.titleService.setTitle(title);
  }
}
